module.exports = __webpack_public_path__ + "media/images/360/weight_loss_bed-f5f8ccf99f23f30419b3b7acc40e9a5c.jpg";